import styled from "styled-components";
import { naira } from "../../../utils/data";
import { th } from "../../../utils/helpers";
import MiniLoader from "../../../utils/MIniLoader";
import CustomReportOverview from "../../../utils/CustomReportOverview";



const ReportOverview = ({ overview, loading }) => {

      return (
            <StyledReportOverview className="h-100">
                  <div className="main-container">
                        <div className="d-flex gap-2">

                              <h4 className="mb-4 grey-bold-text">
                                    Overview
                              </h4>

                              <MiniLoader
                                    load={loading}
                              />

                        </div>

                        <CustomReportOverview
                              overview={overview}
                        />
                  </div>

            </StyledReportOverview>
      );
};

export default ReportOverview;


const StyledReportOverview = styled.div`
      
      white-space: nowrap !important;

`;